import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";

import TransactionRewardList from "@/modules/recognition/user/components/TransactionRewardList";
import { fetchTransactionRewardsQueryOptions } from "@/modules/recognition/user/services";

export const Route = createFileRoute(
  "/_panel/_recognition/recognition/transactions/rewards",
)({
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("My Rewards", { ns: "recognition.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.prefetchQuery(
      fetchTransactionRewardsQueryOptions(),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  return <TransactionRewardList />;
}
